import { CustomerClaimStatusEnum } from "./status-enum";

export const customerClaimStatusColors = {
  [CustomerClaimStatusEnum.PENDING]: "default",
  [CustomerClaimStatusEnum.COMPLETED]: "success",
  [CustomerClaimStatusEnum.CANCELLED]: "error",
};
